import { environment } from './environments/environment';
import * as configQA from './assets/amplify-configuration-envs/aws-config-qa.json';
import * as configLocal from './assets/amplify-configuration-envs/aws-config-local.json';
import * as configDev from './assets/amplify-configuration-envs/aws-config-dev.json';
import * as configRootQA from './assets/amplify-configuration-envs/aws-config-rootqa.json';
import * as configProd from './assets/amplify-configuration-envs/aws-config-prod.json';
import * as configUAT from './assets/amplify-configuration-envs/aws-config-uat.json';
import { enableProdMode } from '@angular/core';
var awsmobile;
var main_config;
switch (environment.environmentName) {
    case 'rootqa': {
        main_config = configRootQA.default;
        console.log('ROOTQA');
        break;
    }
    case 'qa': {
        main_config = configQA.default;
        console.log('QA');
        break;
    }
    case 'dev': {
        main_config = configDev.default;
        console.log('DEV');
        break;
    }
    case 'uat': {
        main_config = configUAT.default;
        console.log('UAT');
        break;
    }
    case 'prod': {
        main_config = configProd.default;
        console.log('PROD');
        enableProdMode();
        break;
    }
    default: {
        main_config = configLocal.default;
        console.log('LOCAL');
        break;
    }
}
awsmobile = {
    "aws_project_region": main_config.aws_project_region,
    "aws_cognito_region": main_config.aws_cognito_region,
    "aws_user_pools_id": main_config.aws_user_pools_id,
    "aws_user_pools_web_client_id": main_config.aws_user_pools_web_client_id,
    "oauth": {
        "domain": main_config.domain,
        "scope": [
            "phone",
            "email",
            "openid",
            "profile",
            "aws.cognito.signin.user.admin"
        ],
        "redirectSignIn": main_config.origin + "auth-callback",
        "redirectSignOut": main_config.origin,
        "responseType": "code"
    }
};
export default awsmobile;
//# sourceMappingURL=aws-exports.js.map